<template>
  <vx-card :title="$t(`Producttypes.${connection.type}`)" v-if="connection">
    <vs-table :data="connection.reading" stripe noDataText="Geen meterstanden">
      <template slot="thead">
        <vs-th>Datum</vs-th>
        <vs-th v-for="header in getHeaders(connection.reading)" :key="header">
          {{ header }} in {{ $t(`Productunity.${connection.type}`) }}</vs-th
        >
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].date">
            {{ toDateString(data[indextr].date) }}
          </vs-td>
          <vs-td
            v-for="header in getHeaders(connection.reading)"
            :key="header"
            :set="
              (countingWheel = getCountingWheel(
                data[indextr].counting_wheels,
                header
              ))
            "
          >
            {{
              countingWheel.customer_reading != null
                ? countingWheel.customer_reading
                : countingWheel.net_manager_reading
            }}
            <vx-tooltip
              style="display: inline-block"
              v-if="countingWheel && !countingWheel.verified"
              text="Deze meterstand is gebruikt bij het berekenen van je termijnbedrag op jouw verzoek."
            >
              <i>
                <vs-icon
                  icon="icon-alert-circle"
                  color="warning"
                  icon-pack="feather"
                ></vs-icon>
              </i>
            </vx-tooltip>
            <vx-tooltip
              style="display: inline-block"
              v-if="
                countingWheel.net_manager_reading != null &&
                  countingWheel.customer_reading != null
              "
              text="Dit is de gecorrigeerde waarde van je meterstand."
            >
              <i> ({{ countingWheel.net_manager_reading }}) </i>
            </vx-tooltip>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import moment from "moment";
export default {
  props: ["id"],
  data() {
    return {
      connection: null
    };
  },
  methods: {
    async getMetering(id) {
      let res = await this.$http().get(`api/meterreading/${id}`);
      return res.data;
    },

    async getConnection(id) {
      let res = await this.$http().get(`api/connections/${id}`);
      res.data.reading = await this.getMetering(id);
      this.connection = res.data;
    },
    toDateString(date) {
      return moment(date)
        .locale("nl")
        .format("LL");
    },
    getHeaders(readings) {
      let res = [].concat
        .apply(
          [],
          readings.map(r => r.counting_wheels)
        )
        .map(c => c.tariff_type);
      return [...new Set(res)];
    },
    getCountingWheel(counting_wheels, header) {
      let counting_wheel = counting_wheels.filter(c => c.tariff_type == header);
      if (counting_wheel.length >= 1) {
        return counting_wheel[0];
      }
      return "";
    }
  },
  async created() {
    await this.getConnection(this.id);
  }
};
</script>

<style></style>
